//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function openNew(documentId: number, editingType?: Types.ExternalEditingType | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/external-editing/{documentId}?";
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
    if (editingType === null)
        throw new Error("The parameter 'editingType' cannot be null.");
    else if (editingType !== undefined)
        url_ += "editingType=" + encodeURIComponent("" + editingType) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigOpenNew,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigOpenNew?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processOpenNew(_response);
    });
}

function processOpenNew(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

export function getEditingDocumentLink(documentId: number, editingType?: Types.ExternalEditingType | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/external-editing/{documentId}?";
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
    if (editingType === null)
        throw new Error("The parameter 'editingType' cannot be null.");
    else if (editingType !== undefined)
        url_ += "editingType=" + encodeURIComponent("" + editingType) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetEditingDocumentLink,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetEditingDocumentLink?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetEditingDocumentLink(_response);
    });
}

function processGetEditingDocumentLink(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

export function updateSingleEditingDocument(documentId: number, config?: AxiosRequestConfig | undefined): Promise<Types.DocumentDto> {
    let url_ = getBaseUrl() + "/api/external-editing/update/{documentId}";
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateSingleEditingDocument,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigUpdateSingleEditingDocument?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateSingleEditingDocument(_response);
    });
}

function processUpdateSingleEditingDocument(response: AxiosResponse): Promise<Types.DocumentDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDocumentDto(resultData200);
        return Promise.resolve<Types.DocumentDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DocumentDto>(null as any);
}

export function isDocumentEditingByUser(documentId: number, config?: AxiosRequestConfig | undefined): Promise<boolean | null> {
    let url_ = getBaseUrl() + "/api/external-editing/is-editing/{documentId}";
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigIsDocumentEditingByUser,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigIsDocumentEditingByUser?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processIsDocumentEditingByUser(_response);
    });
}

function processIsDocumentEditingByUser(response: AxiosResponse): Promise<boolean | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<boolean | null>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean | null>(null as any);
}
let _requestConfigOpenNew: Partial<AxiosRequestConfig> | null;
export function getOpenNewRequestConfig() {
  return _requestConfigOpenNew;
}
export function setOpenNewRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigOpenNew = value;
}
export function patchOpenNewRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigOpenNew = patch(_requestConfigOpenNew ?? {});
}

let _requestConfigGetEditingDocumentLink: Partial<AxiosRequestConfig> | null;
export function getGetEditingDocumentLinkRequestConfig() {
  return _requestConfigGetEditingDocumentLink;
}
export function setGetEditingDocumentLinkRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetEditingDocumentLink = value;
}
export function patchGetEditingDocumentLinkRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetEditingDocumentLink = patch(_requestConfigGetEditingDocumentLink ?? {});
}

let _requestConfigUpdateSingleEditingDocument: Partial<AxiosRequestConfig> | null;
export function getUpdateSingleEditingDocumentRequestConfig() {
  return _requestConfigUpdateSingleEditingDocument;
}
export function setUpdateSingleEditingDocumentRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateSingleEditingDocument = value;
}
export function patchUpdateSingleEditingDocumentRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateSingleEditingDocument = patch(_requestConfigUpdateSingleEditingDocument ?? {});
}

let _requestConfigIsDocumentEditingByUser: Partial<AxiosRequestConfig> | null;
export function getIsDocumentEditingByUserRequestConfig() {
  return _requestConfigIsDocumentEditingByUser;
}
export function setIsDocumentEditingByUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigIsDocumentEditingByUser = value;
}
export function patchIsDocumentEditingByUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigIsDocumentEditingByUser = patch(_requestConfigIsDocumentEditingByUser ?? {});
}